export const HomePageWrapper = {
  display: 'flex',
  flexDirection: 'column',
  gap: { xs: '50px', md: '100px' },
  backgroundImage: 'radial-gradient(#bdaaf4 2px, transparent 2px), radial-gradient(#bdaaf4 2px, #ffffff 2px)',
  backgroundSize: '80px 80px',
  backgroundPosition: '0 0, 40px 40px',
}
